import { render, staticRenderFns } from "./selectInsertionDesign.vue?vue&type=template&id=8bac0654&"
import script from "./selectInsertionDesign.vue?vue&type=script&lang=ts&"
export * from "./selectInsertionDesign.vue?vue&type=script&lang=ts&"
import style0 from "./selectInsertionDesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports